import DateOptions from "./DateOptions";

Date.prototype.getUTCFullYearBCString = function(this: Date) 
{
    let y = this.getUTCFullYear();
    // if (y > 4999)
    // {
    //     y = 9999 - y;
    //     return y + " BCE";
    // }
    // else 
    if (y < 0)
    {
        y = Math.abs(y);
        return y + " BCE";
    }
    return "" + y;
}

Date.prototype.getUTCFullYearBCNumber = function(this: Date)
{
    let y = this.getUTCFullYear();
    // if (y > 4999)
    // {
    //     y = -1 * (9999 - y);
    // }
    return y;
}

Date.prototype.getUTCBCString = function(this: Date, dateOptions: DateOptions = new DateOptions(0))
{
    // Note: yes, those +1's are necessary because month is zero-based, unlike day of the month (which is Date and not Day (which gives numerical day of the week (which _isn't_ zero-based))). Go figure.
    let y = this.getUTCFullYear();
    if (y < 0)
    {
        return Math.abs(y) + " BCE";
    }
    else if (dateOptions.has(DateOptions.YearOnly))
    {
        return y + "";
    }
    else if (dateOptions.has(DateOptions.HideDay))
    {
        return leadingZeroesString(this.getUTCMonth() + 1, 2) + "/" + leadingZeroesString(y, 4);
    }
    else
    {
        return leadingZeroesString(this.getUTCMonth() + 1, 2) + "/" + leadingZeroesString(this.getUTCDate(), 2) + "/" + leadingZeroesString(y, 4);
    }
}

function leadingZeroesString(input : number, desiredLength : number) : string
{
    let result = "" + input;
    while (result.length < desiredLength)
    {
        result = "0" + result;
    }
    return result;
}